module.exports = __webpack_public_path__ + "static/media/profile.c7259aa3.svg";